class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.initMegaItems();
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }

  // initMegaItems() {
  //   const megaList = this.querySelector('.header__submenu--list');
  //   const megaImages = this.querySelectorAll('.mega-images picture');
  //   const megaLinks = this.querySelectorAll('.header__submenu--list a');
    
  //   if (megaList && megaImages && megaLinks) {
  //     megaImages[0].classList.add('active');
  //     for (var i = 0; i < megaLinks.length; i++) {
  //       megaLinks[i].addEventListener('mouseenter', function() {
  //         var index = this.dataset.childPosition;
  //         var image = megaList.querySelector('picture[data-index="' + index + '"]');
  //         for (var i = 0; i < megaImages.length; i++) {
  //           megaImages[i].classList.remove('active')
  //         }
  //         if (image) {
  //           image.classList.add('active')
  //         } else {
  //           megaImages[0].classList.add('active');
  //         }
  //       });
  //     }
  //   }
  // }
}

customElements.define('details-disclosure', DetailsDisclosure);
